export default __webpack_public_path__ + "static/media/plus-circle.6ccef301.svg";